import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ApiService} from "../../../services/api.service";
import {UserService} from "../../../services/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PopupService} from "../../../services/popup.service";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  form: FormGroup;
  errorMessages: any;
  token: any;
  email: any;

  constructor(
    public formBuilder: FormBuilder,
    private apiService: ApiService,
    private userService: UserService,
    private routerService: Router,
    private popup: PopupService,
    private route: ActivatedRoute,
  ) {

    this.form = formBuilder.group(
      {
        email: ["",
          [Validators.required,],
        ],
        password: ["", [Validators.required]],
        password_confirmation: ["", [Validators.required]],
      },
      {updateOn: "blur"}
    );

    this.errorMessages = {
      email: [
        {
          type: "required",
          message: "Email is required"
        },
      ],
      password: [
        {
          type: "required",
          message: "Password is required"
        },
        {
          type: "minlength",
          message: "Password is too short."
        },
      ],
      password_confirmation: [
        {
          type: "required",
          message: "Password is required"
        },
        {
          type: "minlength",
          message: "Password is too short."
        },
      ],
    };


  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
          // @ts-ignore
        this.token = params.token;
          // @ts-ignore
        this.email = params.email;
        }
      );
  }

  /**
   * @desc Login form handler
   */
  processRecover() {
    if(this.email !== this.form.value.email){
      this.popup.error("Error.", "Invalid email provided. Please insert your account email used for password recovery", "OK");
    }

    if(this.token === "" || this.token === null){
      this.popup.error("Error.", "Password cannot be reset. Please try again", "OK");
    }

    let params = {
      email: this.form.value.email,
      password: this.form.value.password,
      password_confirmation: this.form.value.password_confirmation,
      token: this.token,
    };

    this.updatePassword(params);
  }

  /**
   * @desc Call the username and password authentication via API
   * @param params
   * @private
   */
  private updatePassword(params) {
    this.userService.updatePassword(params).then(response => {
      let message = response.data.message;
      this.popup.success("Password reset", message, "OK");
      this.routerService.navigate(['/login']);
    }).catch(error => {
      let message = error.response.data.message;
      this.popup.error("Something went wrong.", message, "OK");
    })
  }

}
